import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './i18n';
import './index.css';
import {initSentry} from './infrastructure/lib/sentry';

function renderApp() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

// Initialize Sentry before rendering so startup/render errors are not lost.
void initSentry().finally(renderApp);
